import { render, staticRenderFns } from "./BrandSummary.vue?vue&type=template&id=99487070"
import script from "./BrandSummary.vue?vue&type=script&lang=js"
export * from "./BrandSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports